import { get, post } from "utils/api";
import { errorMessage } from "actions/message";

/**
 * Fetches recorded contacts for a patient. Backend returns null / 404 for
 * unknown patients — we surface that as `null` to the caller so the screen
 * can show a friendly not-found message.
 *
 * Endpoint: GET /api/tools/recordings/patient/{patientGuid}
 * Response: { patientGuid, patientName, contacts: [...] }
 */
export const fetchPatientRecordings = patientGuid => async dispatch => {
  try {
    return await get(`tools/recordings/patient/${encodeURIComponent(patientGuid)}`);
  } catch (error) {
    dispatch(errorMessage(`Failed to fetch recordings: ${error?.message || error}`));
    return null;
  }
};

/**
 * Generates a GCS signed URL for a recording, valid for ttlMinutes (1..10080).
 *
 * Endpoint: POST /api/tools/recordings/sign
 * Body:     { recordingSid, ttlMinutes }
 * Response: { signedUrl, expiresAtUtc, recordingSid, objectPath }
 */
export const generateSignedUrl = (recordingSid, ttlMinutes) => async dispatch => {
  try {
    return await post("tools/recordings/sign", { recordingSid, ttlMinutes });
  } catch (error) {
    dispatch(errorMessage(`Failed to generate URL: ${error?.message || error}`));
    return null;
  }
};
